import React from 'react';
import "./RelatorioDispAdmin.css";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DisponibilidadeChart = ({ response, month }) => {

    const monthsOptions = [
        { label: "Janeiro", month: '01'},
        { label: "Fevereiro", month: '02' },
        { label: "Março", month: '03'},
        { label: "Abril", month: '04'},
        { label: "Maio", month: '05'},
        { label: "Junho", month: '06'},
        { label: "Julho", month: '07'},
        { label: "Agosto", month: '08' },
        { label: "Setembro", month: '09' },
        { label: "Outubro", month: '10'},
        { label: "Novembro", month: '11'},
        { label: "Dezembro", month: '12'},
      ];

    // const numeroMes = monthsOptions.find((item) => item.label === month)?.month;
    const numeroMes = monthsOptions.find((item) => {
        const monthName = month?.split(" ")[0]; // Extrai apenas o nome do mês
        return item.label === monthName; // Compara apenas o nome do mês
      })?.month;
      
    
    // Função para montar a matriz com base nos dados filtrados
    const createMatrixFromResponse = (filteredData) => {
        const rows = 48; // Intervalos de 30 minutos
        const cols = 31; // Dias do mês
        const matrix = Array.from({ length: rows }, () =>
            Array.from({ length: cols }, () => 0) // Inicializa a matriz com 0
        );

        filteredData.forEach(item => {
            const [day, month, year] = item.data.split('/');
            const dayIndex = parseInt(day) - 1; // Converte para índice de 0
            const intervalIndex = getIntervalIndex(item.intervalo); // Obtém o índice do intervalo

            if (dayIndex >= 0 && dayIndex < cols && intervalIndex >= 0 && intervalIndex < rows) {
                matrix[intervalIndex][dayIndex] = 1; // Marca a célula correspondente
            }
        });
        
        return matrix;
    };

    const getTimeRange = (index) => {
        const startHour = Math.floor(index / 2);
        const startMinutes = (index % 2) * 30;
        const endHour = Math.floor((index + 1) / 2);
        const endMinutes = ((index + 1) % 2) * 30;

        const formatTime = (hour, minutes) => `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

        return `${formatTime(startHour, startMinutes)}-${formatTime(endHour, endMinutes)}`;
    };
    // Função para converter o intervalo em índice da matriz
    const getIntervalIndex = (interval) => {
        const [start, end] = interval.split('-');
        const startHour = parseInt(start.split(':')[0]);
        const startMinutes = parseInt(start.split(':')[1]);
        // Cada intervalo de 30 minutos, então a linha é 0 para 00:00-00:30, 1 para 00:30-01:00, ..., 47 para 23:30-00:00
        return (startHour * 2) + (startMinutes / 30);
    };

    const matrix = createMatrixFromResponse(response); // Cria matriz a partir dos dados filtrados

    // Função para determinar a cor da célula
    const getCellColor = (value) => {
        return value === 1 ? '#059669' : '#ffffff'; // Verde se houver marcação, branco caso contrário
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 20px 24px' }}>
            {
                numeroMes ? 
                <div style={{ background: '#fff', border: '1px solid var(--px-border, #e4e9e7)', borderRadius: 'var(--px-radius-lg, 18px)', boxShadow: 'var(--px-shadow-sm, 0 2px 8px rgba(15,23,42,0.05))', overflow: 'hidden', width: 'fit-content', maxWidth: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap', padding: '14px 18px', borderBottom: '1px solid var(--px-border, #e4e9e7)' }}>
                        <h2 style={{ margin: 0, fontSize: '0.95rem', fontWeight: 700, fontFamily: 'Sora, sans-serif', color: 'var(--px-text, #0f172a)' }}>{`Disponibilidade em ${month}`}</h2>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', fontSize: '0.72rem', color: 'var(--px-text-soft, #5b6b71)', fontWeight: 600 }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                <span style={{ width: 12, height: 12, borderRadius: 3, background: '#059669', display: 'inline-block' }} /> Online
                            </span>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                <span style={{ width: 12, height: 12, borderRadius: 3, background: '#fff', border: '1px solid var(--px-border-strong, #d3dbd8)', display: 'inline-block' }} /> Offline
                            </span>
                        </div>
                    </div>
                    <div style={{ overflow: 'auto', maxHeight: '70vh' }}>
                        <table style={{ margin: '0 auto', fontSize: '0.8rem' }}>
                            <thead>
                                <tr>
                                    <th className="table-header-cell">Tempo/Dia</th>
                                    {[...Array(31)].map((_, index) => (
                                        <th key={index} className="table-header-cell">
                                            {index > 8 ? `${index + 1}/${numeroMes}` : `0${index + 1}/${numeroMes}`}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {matrix.map((row, y) => (
                                    <tr key={y}>
                                        <td className="time-cell">{getTimeRange(y)}</td>
                                        {row.map((value, x) => (
                                            <td
                                                key={x}
                                                style={{
                                                    backgroundColor: getCellColor(value),
                                                    border: '1px solid var(--px-border, #e4e9e7)',
                                                    borderBottom: value === 1 ? 'none' : '1px solid var(--px-border, #e4e9e7)',
                                                    borderTop: 'none',
                                                    padding: '2px',
                                                }}
                                            />
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                :
                ''
            }
        </div>
    );
};

export default DisponibilidadeChart;
